import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

const EditBabyForm = (props) => {
  
  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const params = {
      name: formData.get("name"),
      date_of_birth: formData.get("date_of_birth"),
      diapers: formData.get("diapers"),
      formula: formData.get("formula"),
      formula_type: formData.get("formula_type"),
      formula_amount: formData.get("formula_amount"),
      
    };
    props.updateBaby(props.id, params);
  };
  
  return (
    <>
      <Form className="form pb-5 d-flex" onSubmit={handleSubmit}>
        <div>
          <h3 className="text-center">Baby details</h3>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Name</u></Form.Label>
            <Form.Control
              htmlFor="name"
              id="name"
              name="name"
              type="text"
              defaultValue={props.name}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Date of birth</u></Form.Label>
            <Form.Control
              htmlFor="date_of_birth"
              id="date_of_birth"
              name="date_of_birth"
              type="text"
              defaultValue={props.date_of_birth}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Diapers</u></Form.Label>
            <Form.Control
              htmlFor="diapers"
              id="diapers"
              name="diapers"
              type="text"
              defaultValue={props.diapers}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Formula</u></Form.Label>
            <Form.Control
              htmlFor="formula"
              id="formula"
              name="formula"
              type="text"
              defaultValue={props.formula}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Formula type</u></Form.Label>
            <Form.Control
              htmlFor="formula_type"
              id="formula_type"
              name="formula_type"
              type="text"
              defaultValue={props.formula_type}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Formula amount</u></Form.Label>
            <Form.Control
              htmlFor="formula_amount"
              id="formula_amount"
              name="formula_amount"
              type="text"
              defaultValue={props.formula_amount}
            />
          </Form.Group>
        </div>

        <Button
          variant="primary"
          className="position-fixed bottom-50 end-0 py-3 mb-3"
          type="submit"
        >
          Update Baby
        </Button>
      </Form>
    </>
  );
}

export default EditBabyForm